import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class vendorData {
  vendorId: string;
  addr1: string;
  addr2: string;
  phone: string;
  email: string;
  vendorRegistrationId: any;
  customerId: any
}

@Injectable({
  providedIn: 'root'
})
export class VendorService extends BaseService {

  PATH_OF_API = environment.BaseApiUrl;

  constructor(public httpClient: HttpClient, authService: AuthService) {
    super(authService);
  }

  //register vendor
  public registerVendor(vendorData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/VendorRegisteration', vendorData, { headers: headers });
  }

  //update vendor
  public updateVendor(vendorData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.put<any>(this.PATH_OF_API + '/VendorRegisteration', vendorData, { headers: headers });
  }

  //get vendor details
  public vendorDetails(vendorRegistrationId: any, customerId: any, token: string): Observable<any> {
    customerId = this.authService.getRegistredUserDetails().customerId;
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/VendorRegisteration?vendorRegistrationId=' + vendorRegistrationId + '&customerId=' + customerId, { headers: headers });
  }

  public vendorDetailsByName(vendorId: any, customerId: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/VendorRegisteration/vendorid?vendorId=' + vendorId + '&customerId=' + customerId, { headers: headers });
  }

  //delete vendor
  deleteVendor(vendorRegistrationId: string): Observable<any> {
    return this.httpClient.delete<any>(this.baseUrl + '/VendorRegisteration?vendorRegistrationId=' + vendorRegistrationId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //display all vendors
  public Allvendors(token: string, customerId: any): Observable<vendorData[]> {
    token = this.authService.getToken();
    customerId = this.authService.getRegistredUserDetails().customerId;
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<vendorData[]>(this.PATH_OF_API + '/VendorRegisteration/list?customerId=' + customerId, { headers: headers });
  }

  //Active vendors
  public AllActivevendors(token: string, customerId: any): Observable<vendorData[]> {
    token = this.authService.getToken();
    customerId = this.authService.getRegistredUserDetails().customerId;
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<vendorData[]>(this.PATH_OF_API + '/VendorRegisteration/activeVendors?customerId=' + customerId, { headers: headers });
  }

  public allVendors(customerId: any) {
    customerId = this.authService.getRegistredUserDetails().customerId;
    return this.httpClient.get(this.baseUrl + '/VendorRegisteration/list?customerId=' + customerId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //vendor upload doc
  public uploadFile(file: FileList): Observable<Object> {
    const formData: FormData = new FormData();
    // formData.append('avatar', file, file.name);
    Array.from(file).forEach((file) => formData.append('file', file, file.name))
    return this.httpClient.post(this.baseUrl + '/Users/upload', formData,
      this.headerWithTokenFile()).pipe(map(res => res));
  }

  //upload vendor document
  public uploadVendorDoc(file: FileList, vendorName: any, vendorId: any, custId: any): Observable<Object> {
    const formData: FormData = new FormData();
    Array.from(file).forEach((file) => formData.append('file', file, file.name)),
      formData.append('VendorName', vendorName),
      formData.append('VendorId', vendorId),
      formData.append('CustomerId', custId)
    return this.httpClient.post(this.baseUrl + '/W9Documents/upload', formData,
      this.headerWithTokenFile()).pipe(map(res => res));
  }

  //download Docs
  public downloadVendorDoc(fileName: any, filePath: any) {
    return this.httpClient.get(this.baseUrl + '/W9Documents/downloadFile?docPath=' + filePath + '&fileName=' + fileName,
      this.headerWithTokenFile()).pipe(map(res => res));
  }

  //get vendor doc
  public getVendorDoc(vendorId: any, token: any) {
    return this.httpClient.get(this.baseUrl + '/W9Documents/list?vendorId=' + vendorId,
      this.headerWithTokenGetFiles(token)).pipe(map(res => res));
  }

  //vendor state
  public vendorState() {
    return this.httpClient.get(this.baseUrl + '/vendorlookupdetail/states/list',
      this.headerWithToken()).pipe(map(res => res));
  }

  //vendor csrf token
  public csrfToken() {
    return this.httpClient.get(this.baseUrl + '/W9Documents/csrf-token',
      this.headerWithToken()).pipe(map(res => res));
  }

  //update vendor doc
  public updateVendorDoc(vendorData: any, csrf: any) {
    return this.httpClient.put(this.baseUrl + '/W9Documents', vendorData,
      this.headerWithCSRFTokenFile(csrf)).pipe(map(res => res));
  }

  //vendor toggle
  public vendorTogggle(vendorRegistrationId: any, IsVendorActive: any) {
    var data = {}
    return this.httpClient.put(this.baseUrl +
      '/VendorRegisteration/VendorActivation?vendorRegistrationId='
      + vendorRegistrationId + '&isVendorActive=' + IsVendorActive, data,
      this.headerWithToken()).pipe(map(res => res));
  }

  //vendor Login Access
  public vendorLoginAccess(vendorId: any, isVendorLogin: any) {
    console.log(this.headerWithToken());
    return this.httpClient.put(this.baseUrl +
      '/VendorRegisteration/IsVendorForLogin?vendorId='
      + vendorId + '&isVendorLogin=' + isVendorLogin,null,
      this.headerWithToken()).pipe(map(res => res));
  }
}
